import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import { Grid, Snackbar, Alert as MuiAlert, Autocomplete, Chip, FormControl } from '@mui/material'
import { JsonFormsDispatch } from '@jsonforms/react';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
// Redundant import removed
import TextField from "@mui/material/TextField";
import { JsonForms } from '@jsonforms/react';
import { useJsonForms } from '@jsonforms/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { SvgIcon, CircularProgress } from '@mui/material';
import FileWidget from './FileWidget'
import { download_zip_file } from '../../../store/job/jobSlice';
import { useNavigate } from 'react-router-dom'
import { setPrevStage, setNewStage, clearJobData, clearJobDetail, get_sidebar_menu } from '../../../store/job/jobSlice'
import { api_get_job_count_by_user } from '../../../store/job/jobApi';
import { get_customer_list } from '../../../store/customer/customerSlice';

import { useDispatch, useSelector } from 'react-redux'
import { rankWith, isControl, uiTypeIs, optionIs, and } from '@jsonforms/core';
import { withJsonFormsLayoutProps, withJsonFormsControlProps } from '@jsonforms/react';
import { setCompany, setProcessTab, setProcessHasJobForm, get_company_process, get_company_process_stage, setStageTab } from '../../../store/user/userSlice';
import { get_company_users } from '../../../store/account/accountSlice';
import { isAuth } from '../../../helpers/cookies';
import { debounce } from "lodash";
import { formatDateTime, formatDate } from '../../../helpers/cookies';
import { grey } from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";
import PdfThumbnail from './PdfThumbnail';
import AddIcon from '@mui/icons-material/Add';
import { AddLink } from '@mui/icons-material';
import AddLinkIcon from '@mui/icons-material/AddLink';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DescriptionIcon from '@mui/icons-material/Description';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from '@mui/material/InputAdornment';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const LibraryAddSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2h11a2 2 0 0 1 2 2v11" />
      <path d="M2 4h11a2 2 0 0 1 2 2v11" />
      <path d="M0 6h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="white" />
      <circle cx="16" cy="16" r="6" fill="white" />
      <path d="M16 13v6" />
      <path d="M13 16h6" />
    </g>
  </SvgIcon>
);

const DeleteSvgIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2m-6 5v6m4-6v6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const theme = createTheme({
  components: {
    MuiInputBase: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#000000",
            WebkitTextFillColor: "#000000 !important",
            opacity: 1
          }
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
          backgroundColor: 'white',
          padding: '0 4px',
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '20px',
          width: '100%'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BDBDBD"
          }
        },
        input: {
          "&.Mui-disabled": {
            color: "#000000 !important",
            WebkitTextFillColor: "#000000 !important",
            opacity: 1
          }
        }
      }
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            marginLeft: '1rem',
            marginRight: 0,
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '20px'
        }
      }
    }
  },
});

const SubmittedDateLabelRenderer = ({ uischema, data, label }) => {
  const path = uischema?.scope ? uischema.scope.replace('#/properties/', '').split('/').pop() : 'submitted_date';
  const displayLabel = label || uischema?.text || uischema?.label || "Submitted Date";

  let rawValue = data;
  if (typeof data === 'object' && data !== null) {
    rawValue = data[path] || data['submitted_date'] || data['submitted_time'] || data['created_date'];
  }

  return (
    <TextField
      label={displayLabel}
      value={rawValue ? formatDate(rawValue) : ""}
      fullWidth
      variant="outlined"
      size="small"
      InputProps={{
        readOnly: true,
      }}
      sx={{ mb: 2.5 }}
    />
  );
};

const CompletedDateLabelRenderer = ({ uischema, data, label }) => {
  const path = uischema?.scope ? uischema.scope.replace('#/properties/', '').split('/').pop() : 'completed_file_date';
  const displayLabel = label || uischema?.text || uischema?.label || "Completed Date";

  let rawValue = data;
  if (typeof data === 'object' && data !== null) {
    rawValue = data[path] || data['completed_file_date'] || data['completed_date'];
  }

  return (
    <TextField
      label={displayLabel}
      value={rawValue ? formatDateTime(rawValue) : ""}
      fullWidth
      variant="outlined"
      size="small"
      InputProps={{
        readOnly: true,
      }}
      sx={{ mb: 2.5 }}
    />
  );
};

const BorderedBooleanRenderer = ({ data, handleChange, path, uischema }) => {
  const { label } = uischema;
  const value = data || false;

  // console.log('BorderedBooleanRenderer - label:', label, 'value:', value, 'data:', data, 'path:', path);

  return (
    <Box
      sx={{
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        padding: "8.5px 14px",
        display: "flex",
        alignItems: "center",
        mb: 2.5,
        cursor: 'pointer',
        '&:hover': {
          border: '1px solid rgba(0, 0, 0, 0.87)',
        }
      }}
      onClick={() => {
        // console.log('Checkbox clicked, current value:', value, 'new value:', !value);
        handleChange(path, !value);
      }}
    >
      <input
        type="checkbox"
        checked={value}
        onChange={(e) => {
          // console.log('Checkbox onChange, checked:', e.target.checked);
          handleChange(path, e.target.checked);
        }}
        style={{
          width: "18px",
          height: "18px",
          marginRight: "10px",
          accentColor: "#ff6100",
          cursor: "pointer",
        }}
      />
      <Typography sx={{ flexGrow: 1, color: "text.secondary", fontSize: "1rem" }}>
        {label}
      </Typography>
    </Box>
  );
};

/* ===== STABLE RENDERER FOR DESCRIPTION FIELD ===== */
const DescriptionRenderer = ({ data, handleChange, path, uischema, required }) => {
  const value = data || "";
  const baseLabel = uischema.label || "Description";

  return (
    <TextField
      label={baseLabel}
      required={required}
      placeholder={baseLabel}
      value={value}
      onChange={(e) => handleChange(path, e.target.value)}
      multiline
      minRows={4}
      fullWidth
      variant="outlined"
      size="small"
      // PASSING label to OutlinedInput explicitly to ensure notch calculates correctly
      InputProps={{
        label: baseLabel
      }}
      sx={{
        mb: 2.5,
        '& .MuiOutlinedInput-root': {
          // Remove fixed height so it can grow
          // height: '108px', 
          alignItems: 'flex-start',
        }
      }}
    />
  );
};

/* ===== CUSTOM RENDERER FOR MULTI-CHIP ASSIGN USERS ===== */
const AssignUsersRenderer = ({ data, handleChange, path, schema, uischema, label, required }) => {
  const options = useMemo(() => {
    return schema?.oneOf || schema?.items?.oneOf || [];
  }, [schema]);

  const selectedValues = useMemo(() => {
    if (data === null || data === undefined || data === "") return [];
    if (Array.isArray(data)) return data.map(Number).filter(Boolean);
    if (typeof data === 'string') {
      const trimmed = data.trim();
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) return parsed.map(Number).filter(Boolean);
        } catch (e) { }
      }
      if (trimmed.includes(',')) {
        return trimmed.split(',').map(x => Number(x.trim())).filter(Boolean);
      }
      const n = Number(trimmed);
      return !isNaN(n) && n > 0 ? [n] : [];
    }
    const num = Number(data);
    return !isNaN(num) && num > 0 ? [num] : [];
  }, [data]);

  const selectedOptions = useMemo(() => {
    return selectedValues
      .map(val => options.find(opt => Number(opt.const) === Number(val)) || { const: val, title: `User ${val}` });
  }, [selectedValues, options]);

  return (
    <FormControl fullWidth size="small" sx={{ mb: 2.5 }}>
      <Autocomplete
        multiple
        size="small"
        options={options}
        getOptionLabel={(option) => option?.title || `User ${option?.const ?? ''}`}
        isOptionEqualToValue={(option, val) => Number(option?.const) === Number(val?.const ?? val)}
        value={selectedOptions}
        onChange={(event, newValue) => {
          const ids = newValue.map(item => item.const);
          handleChange(path, ids);
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              key={option.const}
              label={option.title || `User ${option.const}`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ m: 0.25 }}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label || "Assign Users"}
            placeholder={selectedOptions.length === 0 ? "Select user(s)..." : ""}
            required={required && selectedOptions.length === 0}
            size="small"
          />
        )}
      />
    </FormControl>
  );
};

const assignUsersTester = rankWith(
  6,
  (uischema) => uischema.scope === '#/properties/assigned_to' || uischema.options?.renderer === 'AssignUsers'
);

/* ===== CUSTOM RENDERER FOR CUSTOMER FIELD ===== */
const CustomerRenderer = ({ data, handleChange, path, schema, uischema, label, required }) => {
  const options = useMemo(() => {
    return schema?.oneOf || [];
  }, [schema]);

  const selectedOption = useMemo(() => {
    if (data === null || data === undefined || data === "") return null;
    return options.find(opt => opt.const === data) || { const: data, title: `Customer ${data}` };
  }, [data, options]);

  return (
    <FormControl fullWidth size="small" sx={{ mb: 2.5 }}>
      <Autocomplete
        size="small"
        options={options}
        getOptionLabel={(option) => option?.title || `Customer ${option?.const ?? ''}`}
        isOptionEqualToValue={(option, val) => option?.const === (val?.const ?? val)}
        value={selectedOption}
        onChange={(event, newValue) => {
          handleChange(path, newValue ? newValue.const : null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label || uischema.label || "Customer"}
            required={required}
            size="small"
          />
        )}
      />
    </FormControl>
  );
};

const customerTester = rankWith(
  6,
  (uischema) => uischema.scope === '#/properties/customer_id' || uischema.options?.renderer === 'Customer'
);

/* ===== CUSTOM RENDERER FOR REFERENCE # FIELD ===== */
const ReferenceRenderer = ({ data, handleChange, path, uischema, required }) => {
  const value = data || "";
  const baseLabel = uischema.label || "Reference #";
  const label = required && !baseLabel.includes('*') ? `${baseLabel} *` : baseLabel;
  return (
    <TextField
      label={label}
      value={value}
      onChange={(e) => handleChange(path, e.target.value)}
      variant="outlined"
      fullWidth
      size="small"
      InputProps={{
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => handleChange(path, "")}
              edge="end"
              sx={{ p: 0.5 }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={{ mb: 3 }}
    />
  );
};


/* ===== CUSTOM RENDERER FOR REQUEST QUOTE ===== */

const RichTextRenderer = ({ data, handleChange, path, uischema, label, enabled }) => {
  const customSx = uischema.options?.muiGrid?.sx || {};
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link', 'clean']
    ],
  };

  const ctx = useJsonForms();
  const customerList = useSelector(state => state.customer.customer_list);
  const customerId = ctx?.core?.data?.customer_id;
  const selectedCustomer = customerList?.find(c => c.id === customerId);
  const specialInstructions = selectedCustomer?.special_instructions;

  return (
    <Box sx={{ mb: 4, width: '100%', ...customSx }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', mb: 0.5, display: 'block', fontSize: '14px' }}>
        {label}
      </Typography>
      <ReactQuill
        theme="snow"
        value={data || ""}
        onChange={(content) => {
          if (enabled !== false) {
            handleChange(path, content);
          }
        }}
        modules={modules}
        readOnly={enabled === false}
        style={{
          backgroundColor: enabled === false ? '#f5f5f5' : 'white',
          minHeight: '150px',
          width: '100%',
          borderRadius: '4px'
        }}
      />
      {specialInstructions && (
        <TextField
          label="Customer Special Instructions"
          value={specialInstructions}
          multiline
          fullWidth
          variant="outlined"
          size="small"
          InputProps={{
            readOnly: true,
          }}
          sx={{ mt: 2.5 }}
        />
      )}
    </Box>
  );
};


/* ===== CUSTOM RENDERER FOR TIME REQUIRED (DROPDOWN) ===== */
const TimeRequiredRenderer = ({ data, handleChange, path, schema, uischema }) => {
  const options = schema.enum || [];
  const value = data || "";

  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={(event, newValue) => {
        handleChange(path, newValue || "");
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={uischema.label || "Time required to do job"}
          variant="outlined"
          fullWidth
          size="small"
          sx={{ mb: 2.5 }}
        />
      )}
      sx={{ mb: 0 }}
      freeSolo={false}
      disableClearable={false}
    />
  );
};


/* ===== CUSTOM LAYOUT RENDERERS TO INJECT SPACING ===== */
const CustomHorizontalLayoutRenderer = withJsonFormsLayoutProps((props) => {
  const { uischema, renderers, cells, schema, path, enabled, visible } = props;
  if (visible === false) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2.5}>
        {uischema.elements.map((element, index) => (
          <Grid
            item
            xs={12}
            sm={element.options?.xs || (12 / uischema.elements.length)}
            key={index}
            sx={element.options?.muiGrid?.sx || {}}
          >
            <JsonFormsDispatch
              schema={schema}
              uischema={element}
              path={path}
              enabled={enabled}
              renderers={renderers}
              cells={cells}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
});

const CustomVerticalLayoutRenderer = withJsonFormsLayoutProps((props) => {
  const { uischema, renderers, cells, schema, path, enabled, visible } = props;
  if (visible === false) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container direction="column" spacing={2}>
        {uischema.elements.map((element, index) => (
          <Grid item xs={12} key={index}>
            <JsonFormsDispatch
              schema={schema}
              uischema={element}
              path={path}
              enabled={enabled}
              renderers={renderers}
              cells={cells}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
});

// Helper functions defined outside component to avoid scoping issues
const extractDefaults = (schema) => {
  if (!schema || !schema.properties) return {};
  const defaults = {};
  Object.entries(schema.properties).forEach(([key, value]) => {
    if (value && typeof value === 'object' && value.hasOwnProperty('default')) {
      defaults[key] = value.default;
    }
  });
  return defaults;
};

const trimStrings = (obj, excludeKeys = []) => {
  if (typeof obj === "string") {
    return obj.trim();
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => trimStrings(item, excludeKeys));
  }
  if (obj instanceof File) {
    return obj;
  }
  if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (let key in obj) {
      if (excludeKeys.includes(key)) {
        newObj[key] = obj[key]; // keep as-is
      } else {
        newObj[key] = trimStrings(obj[key], excludeKeys);
      }
    }
    return newObj;
  }
  return obj;
};

const isPdf = (u) => {
  if (!u || typeof u !== 'string') return false;
  return /\.pdf($|\?)/i.test(u);
};

/* ===== CUSTOM RENDERER FOR BUTTON ===== */
const ButtonRenderer = ({ uischema }) => {
  const dispatch = useDispatch();
  const { label, options } = uischema;
  const jobDetail = useSelector(state => state.job.job_detail);
  const currentJobId = useSelector(state => state.job.job_id);

  if (options?.onClickAction === "downloadZip" && (!jobDetail?.comp_file_list || jobDetail.comp_file_list.length <= 1)) {
    return null;
  }

  const handleClick = async () => {
    if (options?.onClickAction === 'downloadZip') {
      try {
        const response = await dispatch(download_zip_file({
          job_id: currentJobId,
          comp_file_list: jobDetail.comp_file_list
        })).unwrap();

        const blob = response.data || response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const ref_no = jobDetail?.job_data?.ref_No;
        const fileName = ref_no
          ? `${ref_no} - Completed files.zip`
          : "Completed files.zip";

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Zip download failed:", error);
        alert("Download failed.");
      }
    }
  };

  return (
    <Button
      variant={options?.variant || 'contained'}
      onClick={handleClick}
      sx={{ textTransform: 'none', background: '#ff6100' }}
    >
      {label}
    </Button>
  );
};

const JobForm = (props) => {
  const { mode,
    job_form,
    job_data,
    handleJobForm,
    handleJobSubmit,
    job_id,
    job_detail,
    prev_stage,
    new_stage,
    proof_log_data,
    handleStatusChange,
    handleJobUpdate,
    handleZipDownload,
    company_users_list = [],
  } = props;
  const { selected_company, selected_process_tab, company_process_stage, company_details } = useSelector((state) => state.user);
  const { sidebar_menus } = useSelector((state) => state.job);
  const { company_users } = useSelector((state) => state.account);
  const { customer_list } = useSelector((state) => state.customer);
  const [showErrors, setShowErrors] = useState(false);

  // Hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State
  const [formData, setFormData] = useState(mode === "create" ? {} : null);
  // Ref always holds the latest form data for submit/update without causing re-renders
  const formDataRef = useRef(formData);
  // formReady gates the JsonForms render ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ we wait until both the data 
  // and the supporting lists (customers/users) are applied to avoid showing raw IDs.
  const [formReady, setFormReady] = useState(false);
  const [listsReady, setListsReady] = useState(false);
  const [logoLinkInput, setLogoLinkInput] = useState("");
  const isInitialized = useRef(false);
  const isDirty = useRef(false);
  const prevJobId = useRef(null);
  const lastLoadedJobDetailRef = useRef(null);
  const [formErrors, setFormErrors] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
  const [userJobCounts, setUserJobCounts] = useState({});
  const lastCompanyRef = useRef(null);
  const lastProcessRef = useRef(null);
  const fetchedCompanyListsRef = useRef(null);

  const fetchUserJobCounts = useCallback(() => {
    const rawUsers = (company_users && company_users.length > 0) ? company_users : (company_users_list || []);
    if (!rawUsers || rawUsers.length === 0) return;

    const artistUsers = rawUsers.filter(
      (u) => u && (u.role === 'ADDNECTAR_ARTIST' || u.role === 6)
    );
    if (artistUsers.length === 0) return;

    Promise.all(
      artistUsers.map(async (u) => {
        try {
          const res = await api_get_job_count_by_user(u.id);
          const countVal = typeof res?.data === 'number' ? res.data : (typeof res === 'number' ? res : (res?.data?.count ?? 0));
          return { id: u.id, count: countVal };
        } catch (e) {
          console.error("Error fetching job count for user", u.id, e);
          return { id: u.id, count: 0 };
        }
      })
    ).then((results) => {
      const countsMap = {};
      results.forEach(({ id, count }) => {
        countsMap[id] = count;
      });
      setUserJobCounts(countsMap);
    });
  }, [company_users, company_users_list]);

  // Fetch job counts on mount, when users change, or when mode/job changes
  useEffect(() => {
    fetchUserJobCounts();
  }, [fetchUserJobCounts, job_id, mode]);

  // Effects
  useEffect(() => {
    if (job_id) {
      dispatch({
        type: "job/setJobId",
        payload: job_id
      });
    }
  }, [job_id]);

  // Reset initialization when mode or job changes to prevent data bleeding
  useEffect(() => {
    isInitialized.current = false;
    lastLoadedJobDetailRef.current = null;
    prevJobId.current = null;
    setFormReady(false);
    if (mode === "create") {
      setFormData({});
      dispatch(clearJobDetail());
      dispatch(clearJobData());
    }
  }, [mode, job_id, dispatch]);

  // Fetch company users for dropdown when Chefworks is active


  // Fetch company users and customers for dropdowns
  useEffect(() => {
    if (!selected_company || fetchedCompanyListsRef.current === selected_company) {
      if (!listsReady) setListsReady(true);
      return;
    }
    fetchedCompanyListsRef.current = selected_company;
    const fetchLists = async () => {
      try {
        await Promise.allSettled([
          dispatch(get_customer_list({ page: 1, limit: 1000 })),
          dispatch(get_company_users({ company_id: selected_company, page: 1, limit: 1000 }))
        ]);
      } catch (error) {
        console.error("Error fetching form lists:", error);
      } finally {
        setListsReady(true);
      }
    };
    fetchLists();
  }, [dispatch, selected_company, listsReady]);

  // Handlers

  const handleAddLogoLink = useCallback(() => {
    isDirty.current = true;
    if (!logoLinkInput.trim()) return;

    setFormData((prevData) => {
      const currentLogos = prevData.logo_references || [];
      const updatedLogos = [...currentLogos, logoLinkInput.trim()];
      const nextData = {
        ...prevData,
        logo_references: updatedLogos
      };

      setTimeout(() => {
        handleJobForm(nextData);
      }, 0);

      return nextData;
    });
    setLogoLinkInput("");
  }, [logoLinkInput, handleJobForm]);



  // Handle stage change specifically from JSONForms
  useEffect(() => {
    if (mode === 'update' && formData?.stage) {
      const selectedName = formData.stage;
      const selectedStage = company_process_stage?.find(s => s.name === selectedName);

      if (selectedStage && selectedStage.id !== formData.stage_id) {
        // If stage name changed, sync ID
        // We do this in a quiet way or let handleFormChange handle it?
        // handleFormChange handles logic, but let's ensure ID syncs if user picked from dropdown
      }
    }
  }, [formData?.stage, company_process_stage]);

  // Helper for nested updates
  const setNested = useCallback((obj, path, value) => {
    if (!path) return obj;
    // Handle both dot notation and slash notation (common in JSON Forms)
    const segments = path
      .replace(/\[(\d+)\]/g, '.$1')
      .replace(/\//g, '.')
      .split('.')
      .filter(Boolean);

    const update = (current, segs) => {
      if (segs.length === 0) return value;
      const [head, ...tail] = segs;

      if (Array.isArray(current)) {
        const next = [...current];
        next[head] = update(next[head] || {}, tail);
        return next;
      } else {
        const next = { ...(current || {}) };
        next[head] = update(next[head], tail);
        return next;
      }
    };

    return update(obj || {}, segments);
  }, []);

  const getNested = useCallback((obj, path) => {
    if (!obj || !path) return undefined;
    const segments = path
      .replace(/\[(\d+)\]/g, '.$1')
      .replace(/\//g, '.')
      .split('.')
      .filter(Boolean);
    let current = obj;
    for (const segment of segments) {
      if (current == null) return undefined;
      current = current[segment];
    }
    return current;
  }, []);

  useEffect(() => {
    if (mode === "update" && job_detail) {
      if (job_detail.company_id && lastCompanyRef.current !== job_detail.company_id) {
        lastCompanyRef.current = job_detail.company_id;
        dispatch(setCompany(job_detail.company_id));
      }
      if (job_detail.process_id && lastProcessRef.current !== job_detail.process_id) {
        lastProcessRef.current = job_detail.process_id;
        dispatch(setProcessTab(job_detail.process_id));
        dispatch(setProcessHasJobForm(job_detail.process_id));
      }
    }
  }, [mode, job_detail?.company_id, job_detail?.process_id, dispatch]);

  useEffect(() => {
    if ((mode === "update" || mode === "detail") && job_detail) {
      const currentDetailId = job_detail.id || job_detail.job_id;
      if (job_id && currentDetailId && String(currentDetailId) !== String(job_id)) {
        return;
      }

      if (lastLoadedJobDetailRef.current === job_detail && isInitialized.current) {
        return;
      }
      lastLoadedJobDetailRef.current = job_detail;

      const { job_data } = job_detail;
      const completedFileDate =
        job_data?.completed_file_date ??
        job_data?.job_items?.[0]?.completed_file_date ??
        null;

      const { status, ...cleanJobData } = job_data || {};

      let assignedToVal = [];
      const hasExplicitAssigned = cleanJobData && cleanJobData.hasOwnProperty('assigned_to') && cleanJobData.assigned_to !== undefined && cleanJobData.assigned_to !== null;
      const rawAssigned = hasExplicitAssigned ? cleanJobData.assigned_to : job_detail.assigned_to;

      if (Array.isArray(rawAssigned)) {
        assignedToVal = rawAssigned.map(x => Number(x)).filter(x => !isNaN(x) && x > 0);
      } else if (typeof rawAssigned === 'string') {
        const trimmed = rawAssigned.trim();
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              assignedToVal = parsed.map(x => Number(x)).filter(x => !isNaN(x) && x > 0);
            }
          } catch (e) { }
        } else if (trimmed.includes(',')) {
          assignedToVal = trimmed.split(',').map(x => Number(x.trim())).filter(x => !isNaN(x) && x > 0);
        } else if (!isNaN(Number(trimmed)) && Number(trimmed) > 0) {
          assignedToVal = [Number(trimmed)];
        }
      } else if (typeof rawAssigned === 'number' && rawAssigned > 0) {
        assignedToVal = [rawAssigned];
      }

      if (!hasExplicitAssigned && assignedToVal.length === 0 && job_detail.assigned_to) {
        assignedToVal = [job_detail.assigned_to];
      }

      const formDataToSet = {
        ...cleanJobData,
        assigned_to: assignedToVal,
        job_type: job_data?.job_type || '',
        request_quote: job_data?.request_quote === true || job_data?.request_quote === 'true' || job_data?.request_quote === 1,
        stage: job_detail.stage?.name,
        created_date: formatDateTime(job_detail.created_date),
        submitted_date: formatDate(cleanJobData?.submitted_date || job_detail?.job_data?.submitted_date || job_detail?.submitted_date || job_detail?.job_data?.submitted_date_time || job_detail?.job_data?.job_time || job_detail.created_date),
        completed_file_date: completedFileDate ? completedFileDate : null
      };
      setFormData(formDataToSet);
      formDataRef.current = formDataToSet;
      isInitialized.current = true;
      dispatch(setPrevStage(job_detail.stage?.name));
      setFormReady(true);
    }
  }, [mode, job_detail, dispatch, job_id]);

  useEffect(() => {
    if (mode === "create" && job_form?.job_schema) {
      if (isInitialized.current) return;

      const defaults = extractDefaults(job_form.job_schema);

      // For Chefworks (13), automatically pre-fill the submitter with logged-in user
      if (Number(selected_company) === 13) {
        const currentUser = isAuth();
        if (currentUser) {
          const userEmail = currentUser.email || currentUser.sub || "";
          defaults.submitter = (`${currentUser.first_name} ${currentUser.last_name} - ${userEmail}`).trim();
        }
      }

      // For initial creation, we ignore the job_data prop as it may contain stale data
      // from Redux (from a previously viewed job) that hasn't been cleared yet.
      const newData = { ...defaults, stage: 'New', stage_id: 1 };

      setFormData(newData);
      formDataRef.current = newData;
      isInitialized.current = true;
    }
  }, [mode, job_data, job_form, listsReady]);

  // Handle readiness for both modes
  useEffect(() => {
    if (listsReady && formData) {
      setFormReady(true);
    }
  }, [listsReady, formData]);


  const isEmptyData = (data) => {
    if (data instanceof File) return false;
    if (!data) return true;
    if (Array.isArray(data)) {
      return data.length === 0 || data.every(isEmptyData);
    }
    if (typeof data === "object") {
      if (Object.keys(data).length === 0) return true;

      return Object.values(data).every(isEmptyData);
    }
    return data === "" || data === null || data === undefined;
  };

  const hasEmptyCompletedFile = (data) => {
    if (Array.isArray(data.completed_file) && data.completed_file.length > 0) {
      return false;
    }
    if (Array.isArray(data.job_items) && data.job_items.length > 0) {
      return data.job_items.some(
        (item) => !Array.isArray(item.completed_file) || item.completed_file.length === 0
      );
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedData = trimStrings(formDataRef.current, ["submitted_file", "completed_file", "logo_references"]);

    try {
      if (mode === "create") {
        // Don't send stage/stage_id — let backend auto-resolve
        // based on assigned_to (New if assigned, Unassigned if not)
        delete trimmedData.stage;
        delete trimmedData.stage_id;
      }

      const res = await handleJobSubmit(trimmedData, selected_company, trimmedData.assigned_to, selected_process_tab);
      if (res?.meta?.requestStatus === 'rejected') {
        alert("Job creation failed: " + (res.payload?.detail || res.payload || "Unknown error"));
        return;
      }

      dispatch(clearJobData());
      navigate(`/?process_id=${selected_process_tab || ''}`, { replace: true });

    } catch (error) {
      console.error("Job creation failed:", error);
      alert("Job creation failed: " + error.message);
    }
  };

  const handleApproveQuote = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const approvalNeededStage = company_process_stage?.find(s => s.name === "Approval Needed");

    if (!approvalNeededStage) {
      console.error("Stage 'Approval Needed' not found");
      alert("Stage 'Approval Needed' not found in the current process.");
      return;
    }

    const newData = {
      ...formDataRef.current,
      stage: approvalNeededStage.name,
      stage_id: approvalNeededStage.id
    };
    setFormData(newData);
    formDataRef.current = newData;
    setSnackbar({
      open: true,
      message: "Stage set to 'Approval Needed'. Click UPDATE to save changes.",
      severity: "success"
    });
  };

  const handleUpdate = async (e, dataOverride = null) => {
    if (e) e.preventDefault();

    const dataToUse = dataOverride || formDataRef.current;
    const trimmedData = trimStrings(dataToUse, ["submitted_file", "completed_file", "logo_references"]);

    const isChefworks = Number(selected_company) === 13;
    const bypassValidation = mode === "update" || trimmedData.isAone === false || String(trimmedData.isAone).toLowerCase() === "false";

    if (!bypassValidation) {
      // Logo Name: mandatory ONLY for Chefworks (13)
      if (isChefworks && (!trimmedData.logo_name || !trimmedData.logo_name.trim())) {
        setSnackbar({ open: true, message: "Please fill the Logo name", severity: "error" });
        return;
      }

      // Chefworks Order Number: custom mandatory message ONLY for Chefworks (13)
      if (isChefworks && (!trimmedData.chefworks_order_number || !trimmedData.chefworks_order_number.trim())) {
        setSnackbar({ open: true, message: "Please fill the Chefworks Order Number", severity: "error" });
        return;
      }

      const relevantErrors = formErrors?.filter(err => {
        const path = err.instancePath || "";
        const missingProp = err.params?.missingProperty || "";

        const isFileField =
          path.includes('submitted_file') ||
          path.includes('completed_file') ||
          path.includes('logo_references') ||
          path.includes('description') ||
          missingProp === 'submitted_file' ||
          missingProp === 'completed_file' ||
          missingProp === 'logo_references' ||
          missingProp === 'description';

        // For Chefworks (13): also suppress garment_type, order_number and logo_name schema errors
        const isChefworksExcluded = isChefworks && (
          path.includes('garment_type') || missingProp === 'garment_type' ||
          path.includes('chefworks_order_number') || missingProp === 'chefworks_order_number' ||
          path.includes('logo_name') || missingProp === 'logo_name'
        );


        // Suppress additionalProperties errors (caused by system fields like stage_id,
        // job_type, created_date etc. that we add but are not in schema properties).
        // Also suppress submitted_date format errors (we store a display string, not ISO).
        const isSystemError =
          err.keyword === 'additionalProperties' ||
          (path === '/submitted_date' && err.keyword === 'format');

        return !isFileField && !isChefworksExcluded && !isSystemError;
      }) || [];

      if (relevantErrors.length > 0) {
        console.log("Validation errors:", relevantErrors);
        const errorDetail = relevantErrors.map(err => {
          const field = err.instancePath ? err.instancePath.replace(/^\//, '').replace(/\//g, '.') : (err.params?.missingProperty || "field");

          if (company_details?.domain_prefix === 'slm' || company_details?.company_domain === 'slm.addnectarstudio.com' || String(company_details?.company_domain).includes('slm')) {
            if (field === 'ref_No' || err.params?.missingProperty === 'ref_No') {
              return "Please fill Reference #";
            }
          }

          if (field === 'client_email' || field === 'Client Email' || field === 'customer_email' || field === 'Customer Email' || err.params?.missingProperty === 'client_email') {
            if (err.keyword === 'format' || err.message?.includes('format') || err.message?.includes('pattern')) {
              return "email format is invalid";
            }
          }

          return `${field} ${err.message}`;
        }).join('; ');

        const finalMessage = errorDetail.includes("Please fill Reference #") || errorDetail.includes("email format is invalid") || errorDetail.includes("Invalid Email format")
          ? errorDetail
          : `Validation Error: ${errorDetail}`;

        setSnackbar({ open: true, message: finalMessage, severity: "error" });
        return;
      }

      if (isEmptyData(trimmedData)) {
        setSnackbar({ open: true, message: "Please complete the mandatory fields.", severity: "error" });
        return;
      }

      const hasFiles = (
        (trimmedData.submitted_file && trimmedData.submitted_file.length > 0) ||
        (trimmedData.logo_references && trimmedData.logo_references.length > 0) ||
        (trimmedData.job_items && trimmedData.job_items.some(item => item.submitted_file && item.submitted_file.length > 0))
      );

      if (!hasFiles) {
        setSnackbar({ open: true, message: "Please upload File(s) in 'Your Uploaded File Section'.", severity: "error" });
        return;
      }
    }


    const isCompletedStage = (stage) => {
      if (!stage) return false;
      return typeof stage === 'string' && stage.toLowerCase().trim() === "completed";
    };
    const targetStageName = dataToUse.stage || new_stage;

    if (!bypassValidation && isCompletedStage(targetStageName) && hasEmptyCompletedFile(trimmedData)) {
      alert("Upload Completed File before marking job as Completed");
      return;
    }

    // Determine active/target stage name for validation
    const activeStageId = dataToUse.stage_id || job_detail?.stage_id || (typeof job_detail?.stage === 'object' ? job_detail?.stage?.id : null);
    let activeStageName = dataToUse.stage || (typeof job_detail?.stage === 'string' ? job_detail.stage : job_detail?.stage?.name) || '';
    if (!activeStageName && activeStageId && Array.isArray(company_process_stage)) {
      const foundStage = company_process_stage.find(s => s.id === activeStageId);
      if (foundStage) activeStageName = foundStage.name;
    }
    activeStageName = (activeStageName || '').trim();
    const normalizedStage = activeStageName.toLowerCase();

    // Enforce at least one assigned user on all stages except New and Unassigned
    if (normalizedStage && normalizedStage !== 'new' && normalizedStage !== 'unassigned') {
      const assignedVal = dataToUse.hasOwnProperty('assigned_to') ? dataToUse.assigned_to : (job_detail?.job_data?.assigned_to || job_detail?.assigned_to);
      const hasAssignedUser = Array.isArray(assignedVal)
        ? assignedVal.length > 0
        : (assignedVal !== null && assignedVal !== undefined && assignedVal !== "" && String(assignedVal).trim() !== "[]");
      if (!hasAssignedUser) {
        setSnackbar({
          open: true,
          message: `At least one user must be assigned in the Assign User field`,
          severity: "error",
        });
        return;
      }
    }

    try {
      const result = await handleJobUpdate(trimmedData, job_id);
      if (result.meta?.requestStatus === 'rejected') {
        const errorDetail = result.payload?.detail || result.payload?.message || (typeof result.payload === 'string' ? result.payload : "Job update failed");
        throw new Error(errorDetail);
      }

      // Check stage change logic
      const currentStageName = dataToUse.stage;

      if (prev_stage && currentStageName && prev_stage !== currentStageName) {
        const action_type = 2;
        const payload = { job_id, action_type, prev_stage, new_stage: currentStageName };
        handleStatusChange(payload).catch(err => console.error("Background status change failed:", err));
      }

      dispatch(clearJobData());
      const url = selected_process_tab ? `/job-detail/${job_id}?process_id=${selected_process_tab}` : `/job-detail/${job_id}`;
      navigate(url, { replace: true });
      const params = {
        company_id: job_detail.company_id,
        process_id: job_detail.process_id,
      };
      dispatch(get_company_process_stage(params));
      dispatch(get_sidebar_menu(job_detail.process_id));
    } catch (error) {
      console.error("Job update failed:", error);
      setSnackbar({
        open: true,
        message: error.message || "Job update failed",
        severity: "error",
      });
    }
  };

  const handleDownloadZipFile = async (job_id, comp_file_list) => {
    const ref_no = job_detail?.job_data?.ref_No;
    handleZipDownload(job_id, comp_file_list, ref_no)
  };

  const handleCancel = () => {
    dispatch(clearJobData());

    if (mode === "create") {
      navigate('/');
    }

    if (mode === "update") {
      const url = selected_process_tab ? `/job-detail/${job_id}?process_id=${selected_process_tab}` : `/job-detail/${job_id}`;
      navigate(url);
    }
  };

  /* ==============================================================================================
     MEMOIZED PROPS & SCHEMAS
     ============================================================================================== */


  const buttonTester = useMemo(() => rankWith(
    11,
    uischema => isControl(uischema) && uischema.options?.renderer === 'button'
  ), []);



  /* ---------------------------------------------------------------------------------------------- */

  const submittedDatelabelTester = useMemo(() => rankWith(6, (uischema) => uischema.scope === '#/properties/submitted_date' || uischema.type === 'Submitted Date Label' || uischema.options?.renderer === 'SubmittedDateLabel'), []);
  const completedDatelabelTester = useMemo(() => rankWith(6, (uischema) => uischema.scope === '#/properties/completed_date' || uischema.scope === '#/properties/completed_file_date' || uischema.type === 'Completed Date Label' || uischema.options?.renderer === 'CompletedDateLabel'), []);
  const borderedBooleanTester = useMemo(() => rankWith(3, and(uiTypeIs('Control'), optionIs('renderer', 'BorderedBoolean'))), []);
  const descriptionTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/description'), []);
  const referenceTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/ref_No'), []);
  const requestQuoteTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/request_quote'), []);
  const needQuoteTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/i_need_a_quote'), []);
  const richTextTester = useMemo(() => rankWith(5, optionIs('renderer', 'RichText')), []);
  const instructionsTester = useMemo(() => rankWith(5, (uischema) => uischema.scope === '#/properties/instructions'), []);
  const instructionsLabelTester = useMemo(() => rankWith(5, (uischema) => uischema.scope === '#/properties/Instructions'), []);

  // const jobItemsTester = useMemo(() => rankWith(100, scopeEndsWith('job_items')), []);

  const fileInputTester = useMemo(() => rankWith(
    10,
    uischema => {
      const match = isControl(uischema) &&
        typeof uischema.scope === 'string' &&
        uischema.options?.renderer === 'fileInputTester';

      return match;
    }
  ), []);

  const fileInputWithBrandTester = useMemo(() => rankWith(
    11,
    and(uiTypeIs('Control'), optionIs('renderer', 'FileInputWithBrandOption'))
  ), []);

  const fileNameTester = useMemo(() => rankWith(10, (uischema) => {
    if (!uischema.scope) return false;
    const scope = uischema.scope;
    return (
      scope.endsWith('submitted_file') ||
      scope.endsWith('completed_file') ||
      scope.endsWith('logo_references')
    );
  }), []);

  // Stable renderer components for FileWidget
  const FileWidgetRenderer = useMemo(() => (props) => (
    <FileWidget
      {...props}
      compact={props.path && String(props.path).includes('job_items')}
    />
  ), []);

  const FileInputWithBrandRenderer = useMemo(() => (props) => (
    <FileWidget
      {...props}
      showBrandOption={true}
      proof_log_data={proof_log_data}
      job_id={job_id}
      compact={props.path && String(props.path).includes('job_items')}
    />
  ), [proof_log_data, job_id]);

  const jobTypeTester = useMemo(() => rankWith(5, (uischema) => uischema.scope === '#/properties/job_type'), []);

  const JobTypeRenderer = useMemo(() => (props) => {
    const value = props.data || "";
    let options = props.schema.enum ? [...props.schema.enum] : [];
    if (value && !options.includes(value)) {
      options.push(value);
    }

    return (
      <Autocomplete
        options={options}
        value={value}
        disabled={mode === "update"}
        readOnly={mode === "update"}
        onChange={(event, newValue) => {
          props.handleChange(props.path, newValue || "");
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.uischema.label || "Job / Service Type"}
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              ...params.InputProps,
              sx: mode === "update" ? { color: grey[700] } : {},
            }}
            sx={{ mb: 2.5 }}
          />
        )}
        sx={{ mb: 0 }}
      />
    );
  }, [mode]);

  const renderers = useMemo(() => [
    { tester: rankWith(3, uiTypeIs('HorizontalLayout')), renderer: CustomHorizontalLayoutRenderer },
    { tester: rankWith(3, uiTypeIs('VerticalLayout')), renderer: CustomVerticalLayoutRenderer },
    ...materialRenderers,
    {
      tester: rankWith(5, (uischema) => uischema.options?.renderer === 'TimeRequired' || uischema.scope?.includes('time_required_to_do_job')),
      renderer: withJsonFormsControlProps(TimeRequiredRenderer)
    },
    { tester: jobTypeTester, renderer: withJsonFormsControlProps(JobTypeRenderer) },
    { tester: fileInputWithBrandTester, renderer: FileInputWithBrandRenderer },
    { tester: fileInputTester, renderer: FileWidgetRenderer },
    { tester: fileNameTester, renderer: FileWidgetRenderer },

    { tester: buttonTester, renderer: withJsonFormsLayoutProps(ButtonRenderer) },
    { tester: assignUsersTester, renderer: withJsonFormsControlProps(AssignUsersRenderer) },
    { tester: customerTester, renderer: withJsonFormsControlProps(CustomerRenderer) },
    { tester: submittedDatelabelTester, renderer: withJsonFormsControlProps(SubmittedDateLabelRenderer) },
    { tester: completedDatelabelTester, renderer: withJsonFormsControlProps(CompletedDateLabelRenderer) },
    { tester: borderedBooleanTester, renderer: withJsonFormsControlProps(BorderedBooleanRenderer) },
    { tester: descriptionTester, renderer: withJsonFormsControlProps(DescriptionRenderer) },
    { tester: referenceTester, renderer: withJsonFormsControlProps(ReferenceRenderer) },
    { tester: requestQuoteTester, renderer: withJsonFormsControlProps(BorderedBooleanRenderer) },
    { tester: needQuoteTester, renderer: withJsonFormsControlProps(BorderedBooleanRenderer) },
    { tester: richTextTester, renderer: withJsonFormsControlProps(RichTextRenderer) },
    { tester: instructionsTester, renderer: withJsonFormsControlProps(RichTextRenderer) },
    { tester: instructionsLabelTester, renderer: withJsonFormsControlProps(RichTextRenderer) }
  ], [mode, job_id, proof_log_data, buttonTester, submittedDatelabelTester, completedDatelabelTester, borderedBooleanTester, descriptionTester, referenceTester, requestQuoteTester, needQuoteTester, fileInputWithBrandTester, FileInputWithBrandRenderer, fileInputTester, FileWidgetRenderer, fileNameTester, richTextTester, instructionsTester, instructionsLabelTester, jobTypeTester, JobTypeRenderer, customerTester, CustomerRenderer]);

  // Stabilize the boolean for optional schema logic
  const hasNoCompletedFiles = useMemo(() => {
    return mode === "update" && (!job_detail?.comp_file_list || job_detail.comp_file_list.length === 0);
  }, [mode, job_detail?.comp_file_list]);

  // Stabilize the stage names for dependency array
  const stageNames = useMemo(() => {
    return company_process_stage?.map(s => s.name).join(',') || '';
  }, [company_process_stage]);

  // Stabilize the schema objects for dependency array
  // const jobSchemaStr = useMemo(() => JSON.stringify(job_form?.job_schema), [job_form]);
  // const uiSchemaStr = useMemo(() => JSON.stringify(mode === "update" ? job_form?.job_ui_update_schema : job_form?.job_ui_schema), [job_form, mode]);


  const dynamicSchema = useMemo(() => {
    if (!job_form?.job_schema) return null;

    const schemaCopy = JSON.parse(JSON.stringify(job_form.job_schema));
    // Ensure properties object exists to prevent "Cannot read properties of undefined" errors
    if (!schemaCopy.properties) {
      schemaCopy.properties = {};
    }
    // CRITICAL: Prevent JsonForms from stripping fields during validation.
    // Without this, typing in fields like priority/search_tags clears the text
    // because the validator considers them "additional properties" and removes them.
    delete schemaCopy.additionalProperties;

    // Strip 'default' values from schema in update/detail mode so JsonForms
    // does NOT auto-populate fields on existing jobs. Defaults should only
    // apply when creating a new job (handled manually in the useEffect below).
    if (mode !== "create") {
      Object.values(schemaCopy.properties).forEach(prop => {
        if (prop && typeof prop === 'object') {
          delete prop.default;
        }
      });
    }
    // Global: Remove description from required array
    if (Array.isArray(schemaCopy.required)) {
      schemaCopy.required = schemaCopy.required.filter(f => f !== 'description');
    }

    if (Number(selected_company) === 13) {
      // Remove other Chefworks specific fields from required array
      if (Array.isArray(schemaCopy.required)) {
        schemaCopy.required = schemaCopy.required.filter(f => f !== 'chefworks_order_number' && f !== 'logo_name');
      }
      // Remove pattern / minLength from description and order number so JsonForms won't flag it
      if (schemaCopy.properties.description) {
        delete schemaCopy.properties.description.pattern;
        delete schemaCopy.properties.description.minLength;
      }
      if (schemaCopy.properties.chefworks_order_number) {
        delete schemaCopy.properties.chefworks_order_number.pattern;
        delete schemaCopy.properties.chefworks_order_number.minLength;
      }
      // Remove enum restriction from garment_type (make it a free-text field)
      // if (schemaCopy.properties.garment_type) {
      //   delete schemaCopy.properties.garment_type.enum;
      // }

      // Automatically convert submitter to a dropdown filled with all company users
      if (schemaCopy.properties.submitter) {
        let enumOptions = [];
        if (company_users && Array.isArray(company_users)) {
          enumOptions = company_users
            .filter(u => u && (u.company?.id || u.company_id) === 13) // Explicit safety filter for Company 13
            .map(u => {
              const uEmail = u.email || "";
              const name = `${u.first_name || ""} ${u.last_name || ""}`.trim();
              return (name ? `${name} - ${uEmail}` : uEmail).trim();
            });
        }

        // Find the current logged-in user
        let loggedInUserName = "";
        const currentUser = isAuth();
        if (currentUser) {
          const userEmail = currentUser.email || currentUser.sub || "";
          loggedInUserName = (`${currentUser.first_name} ${currentUser.last_name} - ${userEmail}`).trim();
        }

        if (loggedInUserName && !enumOptions.includes(loggedInUserName)) {
          enumOptions.unshift(loggedInUserName);
        }

        // Apply dropdown constraint and default (default in create mode)
        if (enumOptions.length > 0) {
          schemaCopy.properties.submitter.enum = enumOptions;
        }
        if (mode === "create") {
          schemaCopy.properties.submitter.default = loggedInUserName;
        }
      }
    }

    const uiSchemaCopy = JSON.parse(
      JSON.stringify(
        mode === "update" ? job_form.job_ui_update_schema : job_form.job_ui_schema
      )
    );

    const appendAsterisk = (label, fallback) => {
      const resolvedLabel = label || fallback;
      return resolvedLabel?.includes('*') ? resolvedLabel : `${resolvedLabel} *`;
    };

    const updateControlLabels = (elements = []) => {
      elements.forEach((element) => {
        if (element.scope === '#/properties/logo_name') {
          element.label = appendAsterisk(element.label, 'Logo Name');
        }
        if (element.scope === '#/properties/chefworks_order_number') {
          element.label = appendAsterisk(element.label, 'Chef Works Order Number');
        }
        if (Array.isArray(element.elements)) {
          updateControlLabels(element.elements);
        }
        if (element.options?.detail?.elements) {
          updateControlLabels(element.options.detail.elements);
        }
      });
    };

    if (Number(selected_company) === 13) {
      if (schemaCopy.properties.logo_name) {
        schemaCopy.properties.logo_name.title = appendAsterisk(
          schemaCopy.properties.logo_name.title,
          'Logo Name'
        );
      }
      if (schemaCopy.properties.chefworks_order_number) {
        schemaCopy.properties.chefworks_order_number.title = appendAsterisk(
          schemaCopy.properties.chefworks_order_number.title,
          'Chef Works Order Number'
        );
      }
      updateControlLabels(uiSchemaCopy?.elements);
    }

    // Calculate sorted stages from sidebar_menus
    let sortedStages = [];
    if (sidebar_menus && sidebar_menus.length > 0) {
      const processMenu = sidebar_menus.find(
        menu => Number(menu.id) === Number(selected_process_tab) || String(menu.name).toLowerCase() === 'jobs'
      );
      if (processMenu && processMenu.sub_menus) {
        sortedStages = processMenu.sub_menus
          .filter(m => String(m.name).toLowerCase() !== 'brand library' && String(m.name).toLowerCase() !== 'my library')
          .map(m => m.name);
      }
    }

    // Update enum for 'stage' property if it exists
    if (schemaCopy.properties.stage && sortedStages.length > 0) {
      schemaCopy.properties.stage.enum = sortedStages;
    } else if (company_process_stage?.length && schemaCopy.properties.stage) {
      schemaCopy.properties.stage.enum = [...new Set(company_process_stage.map(
        (stage) => stage.name
      ).filter(n => n !== "Brand Library" && n !== "My Library"))];
    }

    // PATCH: Ensure commonly used fields exist in schema to avoid "No renderer found"
    const ensureProperty = (propName, type = 'string', title = undefined) => {
      if (!schemaCopy.properties[propName]) {
        schemaCopy.properties[propName] = { type, title };
      }
    };

    ensureProperty('logo_name');
    ensureProperty('job_type');
    ensureProperty('instructions');
    ensureProperty('priority');
    ensureProperty('i_need_a_quote', 'boolean', 'I Need a Quote');
    ensureProperty('release_date', 'string');
    ensureProperty('completed_date', 'string');
    ensureProperty('time_required_to_do_job');
    ensureProperty('company_name');
    ensureProperty('search_tags');
    ensureProperty('search_param');
    ensureProperty('description');
    ensureProperty('submitted_date');
    ensureProperty('submitted_file', 'array');
    ensureProperty('completed_file', 'array');
    ensureProperty('logo_references', 'array');
    ensureProperty('job_items', 'array');
    ensureProperty('stage_id', 'integer');
    ensureProperty('stage', 'string');

    // Add Customer dropdown
    const currentUser = isAuth();
    const userRole = currentUser?.role || currentUser?.role_name || "";
    const isArtist = String(userRole).toLowerCase().includes("artist");

    let customerOptions = (customer_list || [])
      .filter(c => c && (c.id || c.code) && (c.is_active || c.id === formData?.customer_id))
      .map(c => ({
        const: c.id,
        title: String(c.code || c.employee_code || `ID: ${c.id}`)
      }));

    if (formData?.customer_id && !customerOptions.some(opt => opt.const === formData.customer_id)) {
      const fallbackTitle = formData._customer_display || formData.customer_code || formData.customer;
      if (fallbackTitle) {
        customerOptions.unshift({
          const: formData.customer_id,
          title: String(fallbackTitle)
        });
      }
    }

    if (customerOptions.length > 0) {
      schemaCopy.properties.customer_id = {
        type: "integer",
        title: "Customer",
        oneOf: customerOptions
      };
    } else if (formData?.customer_id && (formData._customer_display || formData.customer_code)) {
      schemaCopy.properties.customer_id = {
        type: "integer",
        title: "Customer",
        oneOf: [{
          const: formData.customer_id,
          title: String(formData._customer_display || formData.customer_code)
        }]
      };
    } else {
      ensureProperty('customer_id', 'integer', 'Customer');
    }

    // Add Assign Users dropdown / multi-chip
    const effectiveUsers = (company_users && company_users.length > 0) ? company_users : (company_users_list || []);
    if (effectiveUsers && effectiveUsers.length > 0) {
      const assignedOptions = (effectiveUsers || [])
        .filter(u => u && u.id && (u.is_active || (Array.isArray(formData?.assigned_to) ? formData.assigned_to.includes(u.id) : u.id === formData?.assigned_to)))
        .filter(u => u.role === 'ADDNECTAR_ARTIST' || u.role === 6 || (Array.isArray(formData?.assigned_to) ? formData.assigned_to.includes(u.id) : u.id === formData?.assigned_to))
        .map(u => {
          const rawName = String((`${u.first_name || ""} ${u.last_name || ""}`).trim() || u.email || `User ${u.id}`);
          const count = userJobCounts[u.id];
          const title = count !== undefined ? `${rawName} (${count})` : rawName;
          return {
            const: u.id,
            title: title
          };
        });

      // Add currently assigned user as fallback if they are missing from the list (e.g. an Addnectar artist assigned to a customer job)
      const currentAssignedIds = Array.isArray(formData?.assigned_to) ? formData.assigned_to : (formData?.assigned_to ? [formData.assigned_to] : []);
      currentAssignedIds.forEach(id => {
        if (!assignedOptions.some(opt => opt.const === id)) {
          assignedOptions.push({
            const: id,
            title: `Assigned User ID: ${id}`
          });
        }
      });

      schemaCopy.properties.assigned_to = {
        type: ["array", "integer"],
        title: "Assign Users",
        items: {
          type: "integer",
          oneOf: assignedOptions
        },
        oneOf: assignedOptions
      };
    } else {
      ensureProperty('assigned_to', 'array', 'Assign Users');
    }

    // Add to UI schema if not present
    const hasField = (elements, field) => {
      if (!elements) return false;
      return elements.some(el => {
        if (el.scope === `#/properties/${field}`) return true;
        if (el.elements) return hasField(el.elements, field);
        if (el.options?.detail?.elements) return hasField(el.options.detail.elements, field);
        return false;
      });
    };

    if (mode === "create") {
      const removeFieldFromUiSchema = (elements, field) => {
        if (!elements) return;
        for (let i = elements.length - 1; i >= 0; i--) {
          const el = elements[i];
          if (el.scope === `#/properties/${field}`) {
            elements.splice(i, 1);
          } else if (el.elements) {
            removeFieldFromUiSchema(el.elements, field);
          }
        }
      };
      removeFieldFromUiSchema(uiSchemaCopy.elements, 'assigned_to');
    }

    if (!hasField(uiSchemaCopy.elements, 'customer_id') || (mode !== "create" && !hasField(uiSchemaCopy.elements, 'assigned_to'))) {
      const topFields = [];
      if (!hasField(uiSchemaCopy.elements, 'customer_id')) {
        topFields.push({ type: "Control", scope: "#/properties/customer_id", label: "Customer" });
      }
      if (mode !== "create" && !hasField(uiSchemaCopy.elements, 'assigned_to')) {
        topFields.push({ type: "Control", scope: "#/properties/assigned_to", label: "Assign Users" });
      }

      if (topFields.length > 0) {
        uiSchemaCopy.elements.unshift({
          type: "HorizontalLayout",
          elements: topFields
        });
      }
    }

    // Force job_items to be array
    if (schemaCopy.properties.job_items) {
      schemaCopy.properties.job_items.type = 'array';
    } else {
      schemaCopy.properties.job_items = {
        type: "array",
        title: "Job Items",
        items: {
          type: "object",
          properties: {}
        }
      };
    }

    // Place job_items UI element right after the Instructions control so Job Items appear below instructions
    const placeJobItemsBelowInstructions = (ui) => {
      if (!ui || !ui.elements) return;
      let jobEl = null;

      const removeJob = (elements) => {
        if (!elements) return false;
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (!el) continue;

          if (el.scope === "#/properties/job_items") {
            jobEl = el;
            elements.splice(i, 1);
            return true;
          }

          if (el.elements && removeJob(el.elements)) return true;
          if (el.options && el.options.detail && Array.isArray(el.options.detail.elements) && removeJob(el.options.detail.elements)) return true;
        }
        return false;
      };

      // Remove job_items from wherever it is
      removeJob(ui.elements);

      if (!jobEl) return;

      let inserted = false;
      const insertAfterInstructions = (elements) => {
        if (!elements) return false;
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (!el) continue;

          if (el.scope === "#/properties/instructions") {
            elements.splice(i + 1, 0, jobEl);
            inserted = true;
            return true;
          }

          if (el.elements && insertAfterInstructions(el.elements)) return true;
          if (el.options && el.options.detail && Array.isArray(el.options.detail.elements) && insertAfterInstructions(el.options.detail.elements)) return true;
        }
        return false;
      };

      insertAfterInstructions(ui.elements);

      // Fallback: append to end if we couldn't find Instructions
      if (!inserted) ui.elements.push(jobEl);
    };

    // Force 3-column layout where applicable
    const applyThreeColumnLayout = (ui) => {
      if (!ui || !ui.elements) return;

      const oldElements = [...ui.elements];
      ui.elements = [];

      const collectedStandard = [];
      const collectedFiles = [];

      const flushStandard = () => {
        while (collectedStandard.length > 0) {
          const row = collectedStandard.splice(0, 3);
          ui.elements.push({
            type: "HorizontalLayout",
            options: { spacing: 2 },
            elements: row
          });
        }
      };

      const flushFiles = () => {
        while (collectedFiles.length > 0) {
          const row = collectedFiles.splice(0, 2);
          ui.elements.push({
            type: "HorizontalLayout",
            options: { spacing: 2 },
            elements: row
          });
        }
      };

      const processElements = (elements) => {
        elements.forEach(el => {
          if (el.type === 'Control') {
            if (el.scope === '#/properties/instructions') {
              flushStandard();
              flushFiles();
              ui.elements.push({ ...el, options: { ...el.options, xs: 12 } });
            } else if (el.scope?.includes('file')) {
              flushStandard();
              collectedFiles.push({ ...el, options: { ...el.options, xs: 6 } });
            } else if (el.scope?.includes('job_items')) {
              flushStandard();
              flushFiles();
              ui.elements.push(el);
            } else {
              flushFiles();
              collectedStandard.push({ ...el, options: { ...el.options, xs: 4 } });
            }
          } else if (el.type === 'HorizontalLayout' || el.type === 'VerticalLayout') {
            if (el.elements) processElements(el.elements);
          } else {
            flushStandard();
            flushFiles();
            ui.elements.push(el);
          }
        });
      };

      processElements(oldElements);
      flushStandard();
      flushFiles();
    };

    applyThreeColumnLayout(uiSchemaCopy);

    // Force instructions to be full width
    const makeInstructionsFullWidth = (elements) => {
      if (!elements) return;
      elements.forEach(el => {
        if (el.scope === "#/properties/instructions") {
          el.options = { ...el.options, xs: 12 };
        }
        if (el.elements) makeInstructionsFullWidth(el.elements);
      });
    };
    makeInstructionsFullWidth(uiSchemaCopy.elements);

    placeJobItemsBelowInstructions(uiSchemaCopy);

    if (schemaCopy.properties.job_items.type === 'array') {
      if (!schemaCopy.properties.job_items.items) {
        schemaCopy.properties.job_items.items = { type: "object", properties: {} };
      }
      if (!schemaCopy.properties.job_items.items.properties) {
        schemaCopy.properties.job_items.items.properties = {};
      }

      const itemProps = schemaCopy.properties.job_items.items.properties;
      const ensureItemProp = (pName, pType = 'string') => {
        if (!itemProps[pName]) itemProps[pName] = { type: pType };
      };

      ensureItemProp('item');
      ensureItemProp('product_color');
      ensureItemProp('imprint_color');
      ensureItemProp('imprint_location');
      ensureItemProp('imprint_instruction');
      ensureItemProp('submitted_file', 'array');
      ensureItemProp('completed_file', 'array');
    }

    // Ensure stage control exists in UI schema for update mode
    // In create mode, stage is auto-resolved by the backend, so we make it read-only
    if (schemaCopy.properties?.stage) {
      // Check if stage control already exists in UI schema
      const hasStageControl = (elements) => {
        if (!elements) return false;
        return elements.some(el => {
          if (el.scope === "#/properties/stage") return true;
          if (el.elements) return hasStageControl(el.elements);
          return false;
        });
      };

      if (mode === "create") {
        // In create mode: remove any existing stage control from UI schema
        // so the field is not visible (backend auto-resolves it)
        const removeStageControl = (elements) => {
          if (!elements) return;
          for (let i = elements.length - 1; i >= 0; i--) {
            const el = elements[i];
            if (el.scope === "#/properties/stage" || el.scope === "#/properties/stage_id") {
              elements.splice(i, 1);
            } else {
              if (el.elements) removeStageControl(el.elements);
            }
          }
        };
        removeStageControl(uiSchemaCopy.elements);
      } else if (mode === "update") {
        if (!hasStageControl(uiSchemaCopy.elements)) {
          // Try to find the right column to add stage
          if (uiSchemaCopy.type === "HorizontalLayout" && uiSchemaCopy.elements?.length >= 2) {
            const rightColumn = uiSchemaCopy.elements[1];
            if (rightColumn.type === "VerticalLayout" && rightColumn.elements) {
              // Add stage after the first element
              rightColumn.elements.splice(1, 0, {
                type: "Control",
                label: "Stage",
                scope: "#/properties/stage"
              });
            }
          }
        }
      }
    }

    if (hasNoCompletedFiles) {
      const removeCompletedDateInsideJobItems = (elements, insideJobItems = false) => {
        if (!elements) return [];

        return elements
          .map((el) => {
            if (el.scope === "#/properties/job_items" && el.options?.detail?.elements) {
              el.options.detail.elements = removeCompletedDateInsideJobItems(
                el.options.detail.elements,
                true
              );
            }

            if (el.elements) {
              el.elements = removeCompletedDateInsideJobItems(el.elements, insideJobItems);
            }

            return el;
          })
          .filter((el) => {
            if (insideJobItems && el.type === "Completed Date Label") {
              return false;
            }
            return true;
          });
      };

      uiSchemaCopy.elements = removeCompletedDateInsideJobItems(uiSchemaCopy.elements);
    }

    // ---------- BYPASS ALL REQUIRED VALIDATIONS ----------
    schemaCopy.required = [];

    return { schema: schemaCopy, uiSchema: uiSchemaCopy };
  }, [stageNames, mode, hasNoCompletedFiles, company_process_stage, job_form, sidebar_menus, company_users, company_users_list, customer_list, selected_company, formData?.isAone, userJobCounts]);

  // Use a ref for job_data comparison so the debounced function doesn't
  // recreate when Redux state updates (which would cause text fields to clear)
  const jobDataRef = useRef(job_data);
  useEffect(() => { jobDataRef.current = job_data; }, [job_data]);

  const debouncedHandleJobForm = useMemo(
    () => debounce((newData) => {
      try {
        if (JSON.stringify(newData) === JSON.stringify(jobDataRef.current)) return;
      } catch (e) {
        // If stringify fails, fall back to dispatching
      }
      handleJobForm(newData);
    }, 1000),
    [handleJobForm]
  );

  useEffect(() => {
    return () => {
      debouncedHandleJobForm.cancel();
    };
  }, [debouncedHandleJobForm]);

  const handleFormChange = useCallback(({ data, errors }) => {
    isDirty.current = true;
    // Ensure job_items is always an array
    const updatedData = { ...data, job_items: Array.isArray(data.job_items) ? data.job_items : [] };

    // Store latest data in ref (no state update = no re-render = smooth typing)
    formDataRef.current = updatedData;
    setFormErrors(errors);
    debouncedHandleJobForm(updatedData);
  }, [debouncedHandleJobForm]);

  return (
    <Box className='jobWrapper' sx={{ flex: 1, mr: 1 }}>
      <Box
        sx={{
          bgcolor: "#fff",
          px: 2,
          mt: 0,
          py: 1.5, // Standardized padding
          minHeight: '45px',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          borderBottom: '20px solid #FFF5F2',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {/* LEFT SIDE */}
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            color: 'black',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/')}
        >
          {mode === "update"
            ? `Update Job / ${job_id}`
            : "Create Job"}
        </Typography>

        {/* RIGHT SIDE BUTTONS */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {mode === "update" ? (
            <Button
              variant="contained"
              type='submit'
              form="job-form"
              sx={{
                backgroundColor: '#ff6100',
                color: '#fff',
                textTransform: 'none',
                borderRadius: '5px',
                fontSize: '14px',
                px: 3,
                py: 0.75,
                '&:hover': {
                  backgroundColor: '#e55600'
                }
              }}
            >
              UPDATE
            </Button>
          ) : (
            <>
              <Button
                variant="outlined"
                onClick={() => navigate('/')}
                sx={{
                  color: '#ff6100',
                  borderColor: '#ff6100',
                  textTransform: 'none',
                  borderRadius: '5px',
                  fontSize: '14px',
                  px: 3,
                  py: 0.75,
                  '&:hover': {
                    borderColor: '#e55600',
                    backgroundColor: 'rgba(255, 97, 0, 0.04)'
                  }
                }}
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                type='submit'
                form="job-form"
                sx={{
                  backgroundColor: '#ff6100',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '5px',
                  fontSize: '14px',
                  px: 3,
                  py: 0.75,
                  '&:hover': {
                    backgroundColor: '#e55600'
                  }
                }}
              >
                CREATE
              </Button>
            </>
          )}
        </Box>
      </Box>
      <Box sx={{
        px: 2,
        py: 2,
        bgcolor: 'white',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        width: '100%',
        maxWidth: '100%'
      }}>
        {mode === "update" && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "text.primary",
              }}
            >
              Job #: {job_id}
            </Typography>
          </Box>
        )}

        <ThemeProvider theme={theme}>
          <form
            id="job-form"
            onSubmit={mode === "update" ? handleUpdate : handleSubmit}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="error" sx={{ fontStyle: 'italic' }}>
                All <span style={{ color: 'red' }}>*</span> fields are mandatory
              </Typography>
            </Box>


            {/* Show spinner while waiting for defaults to be applied (create mode)
                or while job detail/lists are loading. */}
            {(!formReady || !listsReady || (mode === "update" && formData === null) || !dynamicSchema) && (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}>
                <CircularProgress sx={{ color: '#ff6100' }} />
              </Box>
            )}

            {formReady && formData !== null && dynamicSchema !== null && (
              <JsonForms
                schema={dynamicSchema.schema}
                uischema={dynamicSchema.uiSchema}
                data={formData}
                renderers={renderers}
                cells={materialCells}
                onChange={handleFormChange}
                validationMode={showErrors ? "ValidateAndShow" : "ValidateAndHide"}
              />
            )}

            {/* BOTTOM BUTTONS */}
            {formReady && formData !== null && dynamicSchema !== null && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4, mb: 2 }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/')}
                  sx={{
                    color: '#ff6100',
                    borderColor: '#ff6100',
                    textTransform: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                    px: 4,
                    py: 1,
                    '&:hover': {
                      borderColor: '#e55600',
                      backgroundColor: 'rgba(255, 97, 0, 0.04)'
                    }
                  }}
                >
                  CANCEL
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    backgroundColor: '#ff6100',
                    color: '#fff',
                    textTransform: 'none',
                    borderRadius: '5px',
                    fontSize: '14px',
                    px: 4,
                    py: 1,
                    '&:hover': {
                      backgroundColor: '#e55600'
                    }
                  }}
                >
                  {mode === "update" ? "UPDATE" : "CREATE"}
                </Button>
              </Box>
            )}
          </form>

          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
              {snackbar.message}
            </Alert>
          </Snackbar>
        </ThemeProvider>
      </Box>
    </Box >
  )
}

export default JobForm;
